import { api, apiFile } from 'api/api';
import { DiagnosticoEmissaoDireta, UnidadeOrganizacionalCertificado } from 'model/fiscal/UnidadeOrganizacionalCertificado';

export default class UnidadeOrganizacionalCertificadoService {
    async listar(unidade: number): Promise<UnidadeOrganizacionalCertificado[]> {
        return (await api.get<UnidadeOrganizacionalCertificado[]>(`/unidadeOrganizacional/${unidade}/certificados`)).data;
    }
    async cadastrar(unidade: number, arquivo: File, senha: string): Promise<UnidadeOrganizacionalCertificado> {
        const form = new FormData();
        form.append('arquivo', arquivo);
        form.append('senha', senha);
        return (await apiFile.post<UnidadeOrganizacionalCertificado>(`/unidadeOrganizacional/${unidade}/certificados`, form)).data;
    }
    async bloquear(unidade: number, id: number): Promise<void> {
        await api.post(`/unidadeOrganizacional/${unidade}/certificados/${id}/bloquear`);
    }
    async diagnosticar(unidade: number): Promise<DiagnosticoEmissaoDireta> {
        return (await api.get<DiagnosticoEmissaoDireta>(`/unidadeOrganizacional/${unidade}/emissaoDireta/diagnostico`)).data;
    }
}
